import { BeaconErrorType } from '@airgap/beacon-types';
import { BeaconError } from './BeaconError';
/**
 * @category Error
 */
export class AbortedBeaconError extends BeaconError {
    name = 'UnknownBeaconError';
    title = 'Aborted';
    constructor() {
        super(BeaconErrorType.ABORTED_ERROR, 'The action was aborted by the user.');
    }
}
//# sourceMappingURL=AbortedBeaconError.js.map